const PORTFOLIO_SETTINGS_ENDPOINT =
  'https://mediumturquoise-bear-605933.hostingersite.com/wp-json/wp/v2/portfolio_settings';

const PROJECTS_ENDPOINT =
  'https://mediumturquoise-bear-605933.hostingersite.com/wp-json/wp/v2/projects';

const CONTACT_ENDPOINT =
  'https://mediumturquoise-bear-605933.hostingersite.com/wp-json/greta-forms/v1/contact';

const cleanText = (value, fallback) =>
  typeof value === 'string' && value.trim() ? value.trim() : fallback;

const cleanUrl = (value, fallback) =>
  typeof value === 'string' && value.trim() ? value.trim() : fallback;

const stripHtml = (value) =>
  typeof value === 'string' ? value.replace(/<[^>]*>/g, '').trim() : '';

export async function fetchPortfolioSettings(fallback) {
  const response = await fetch(PORTFOLIO_SETTINGS_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Portfolio Settings request failed: ${response.status}`);
  }

  const records = await response.json();
  const record = Array.isArray(records) ? records[0] : null;
  const meta = record?.meta;

  if (!meta) {
    throw new Error('Portfolio Settings response did not contain meta fields');
  }

  return {
    ...fallback,
    hero_eyebrow: cleanText(meta.hero_eyebrow, fallback.hero_eyebrow),
    hero_heading: cleanText(meta.hero_heading, fallback.hero_heading),
    hero_description: cleanText(
      meta.hero_description,
      fallback.hero_description
    ),
    hero_cta_text: cleanText(meta.hero_cta_text, fallback.hero_cta_text),
    hero_cta_url: cleanUrl(meta.hero_cta_url, fallback.hero_cta_url),
    hero_image: {
      ...fallback.hero_image,
      url: cleanUrl(meta.hero_image, fallback.hero_image.url)
    },
    contact_heading: cleanText(
      meta.contact_heading,
      fallback.contact_heading
    ),
    contact_text: cleanText(meta.contact_text, fallback.contact_text),
    contact_email: cleanText(meta.contact_email, fallback.contact_email),
    contact_image: {
      ...fallback.contact_image,
      url: cleanUrl(meta.contact_image, fallback.contact_image.url)
    }
  };
}

export async function fetchProjects(fallback) {
  const response = await fetch(PROJECTS_ENDPOINT);

  if (!response.ok) {
    throw new Error(`Projects request failed: ${response.status}`);
  }

  const records = await response.json();

  if (!Array.isArray(records)) {
    throw new Error('Projects response was not an array');
  }

  return records.map((record, index) => {
    const fallbackProject = fallback[index] || {};
    const fallbackImage = fallbackProject.project_image || {};
    const title = cleanText(
      stripHtml(record.title?.rendered),
      fallbackProject.title || 'Untitled project'
    );

    return {
      id: record.id ?? fallbackProject.id ?? `project-${index}`,
      title,
      project_category: cleanText(
        record.meta?.project_category,
        fallbackProject.project_category || ''
      ),
      project_description: cleanText(
        record.meta?.project_description,
        fallbackProject.project_description || ''
      ),
      project_image: {
        ...fallbackImage,
        url: cleanUrl(
          record.meta?.project_image,
          fallbackImage.url || ''
        ),
        alt: title
      }
    };
  });
}

export async function submitContactForm(payload) {
  const response = await fetch(CONTACT_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      name: payload.name,
      email: payload.email,
      message: payload.message
    })
  });

  let result = null;

  try {
    result = await response.json();
  } catch {
    result = null;
  }

  if (!response.ok || result?.code !== 'success') {
    throw new Error('Contact submission failed');
  }

  return result;
}